import {Component, ViewEncapsulation} from '@angular/core';
import {environment} from 'src/environments/environment';
import {CookieConsentService} from '../../shared/services/cookie-consent.service';
import {ApiService} from '../../shared/services/api.service';

@Component({
  selector: 'app-cookie-consent',
  templateUrl: './cookie-consent.component.html',
  styleUrls: ['./cookie-consent.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CookieConsentComponent {
  constructor(public consent: CookieConsentService, private api: ApiService) {}

  get visible(): boolean {
    return !!(environment.requireCookieConsent && this.api.userRole?.isCustomer && !this.consent.hasDecided);
  }

  accept(): void {
    this.consent.accept();
  }

  refuse(): void {
    this.consent.refuse();
  }
}
